import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  // GENERAL
  body: {
    paddingTop: 25,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  // VERY TOP
  tiptopfHeader: {
    display: "flex",
    flexDirection: "row",
    alignContent: "flex-end",
    width: "100%",
  },
  // LOGO
  logo: {
    width: "15%",
    // marginLeft: "auto",
    // backgroundColor: "black",
  },
  // TOP
  header: {
    fontSize: 12,
    marginBottom: 10,
    fontFamily: "Proxima Nova Bold",
    flexDirection: "row",
  },
  // TITLE
  headerTitleCol: {
    width: "60%",
    marginLeft: 12,
    marginRight: 48,
  },
  title: {
    marginTop: "auto",
    fontSize: 32,
    fontFamily: "Proxima Nova Bold",
    marginBottom: -6,
  },
  // IMAGE
  headerImgCol: {
    width: "39%",
  },
  image: {
    marginVertical: 0,
    marginHorizontal: 0,
  },
  // BODY
  mainView: {
    flexDirection: "row",
    marginBottom: 20,
    marginTop: 32,
  },
  // LEFT SIDE
  leftSide: {
    width: "24%",
    flexDirection: "column",
    paddingBottom: 8,
  },
  preparation: {
    flexDirection: "column",
    paddingTop: 8,
    paddingBottom: 8,
    border: "1px solid black",
    borderRight: "none",
    borderLeft: "none",
  },
  prepTimeIcon: {
    width: 10,
    height: 10,
    marginRight: 4,
    marginTop: "auto",
    marginBottom: "auto",
  },
  stepView: {
    flexDirection: "row",
  },
  row: {
    flexDirection: "row",
    marginBottom: 4,
  },
  // Text
  textBold: {
    fontSize: 9,
    fontFamily: "Proxima Nova Bold",
  },
  stepTitle: {
    fontSize: 9,
    fontFamily: "Proxima Nova Bold",
    marginBottom: 4,
  },
  textRegular: {
    fontSize: 9,
    fontFamily: "Proxima Nova Regular",
    lineHeight: 1.2,
  },
  // RIGHT SIDE
  rightSide: {
    width: "76%",
    flexDirection: "column",
    // paddingBottom: 8,
    paddingLeft: 12,
  },
  textDescription: {
    fontSize: 9,
    fontFamily: "Proxima Nova Regular",
    marginBottom: 3,
    lineHeight: 1.2,
  },
  // TIPP
  tippView: {
    marginTop: 8,
    marginBottom: 8,
    flexDirection: "column",
    marginRight: 8,
  },
  tippLabel: {
    fontSize: 12,
    marginTop: 20,
    marginBottom: 10,
    fontFamily: "Proxima Nova Bold",
  },
  rezeptTipp: {
    fontSize: 12,
    marginRight: 12,
    fontFamily: "Proxima Nova Regular",
  },
  tippElement: {
    flexDirection: "row",
    marginBottom: 4,
  },
  tippBulletPoint: {
    width: 3,
    height: 3,
    // borderRadius: "50%",
    marginRight: 4,
    marginTop: 4,
    marginBottom: "auto",
    backgroundColor: "black",
  },
  // BOTTOM
  link: {
    position: "absolute",
    fontSize: 8,
    bottom: 30,
    left: 36,
  },
  pageNumber: {
    position: "absolute",
    fontSize: 8,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
  },
});
